
import { useEffect, useState } from 'react';
import ApplicationTable from '../../components/ApplicationTable';
import AddApplicationModal from '../../components/AddApplicationModal';
import MultiSelectFilter from '../../components/MultiSelectFilter';
import { educatorColumns, educatorColumnstable } from "../../components/ApplicationListData";
import { useAuth } from '../../contexts/AuthContext';
import { PlusIcon } from '@heroicons/react/24/outline';
import { applicationService } from '../../services/applicationService';
import Filters from '../../components/MultiSelectFilter';




function ApplicationsList({ userRole,permission }) {
  const { user } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modelType, setModelType] = useState('')
  const [allApplicationList, setAllApplicationList] = useState([])
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [pagination, setPagination] = useState({})
  const [allGradeList, setAllGradeLIst] = useState([])
  const [allApplicationListFilter, setAllApplicationListFilter] = useState([])
  const [allStatusList, setAllStatusList] = useState([])
  // State for all filters
  const [selectedFilters, setSelectedFilters] = useState({
    apps: [],
    grades: [],
    status: [],
    // adoption: [],
  });
  const [selectedFiltersIds, setSelectedFiltersIds] = useState({
    apps: "",
    grades: "",
    status: "",
    // adoption: "",
  });
  const [loader, setLoader] = useState(false)


  const filterConfigs = [
    { key: "apps", label: "All Applications", options: allApplicationListFilter, color: "blue" },
    { key: "grades", label: "All Grades", options: allGradeList, color: "green" },
    { key: "status", label: "All Status", options: allStatusList, color: "orange" },
    // { key: "adoption", label: "All Adoption Levels", options: [{ id: "1", name: "Low" }, { id: "2", name: "Medium" }, { id: "2", name: "High" }], color: "orange" },
  ];

  const isAdmin = userRole?.role_name === 'Admin';

  useEffect(() => {
    getAllGradeData()
    getAllApplicationForFilter()
    getAllApplicationStatusForFilter()
  }, [])

  useEffect(() => {
    getAllApplicationList()
  }, [page, pageLimit, selectedFiltersIds?.apps, selectedFiltersIds?.grades, selectedFiltersIds?.status])


  async function getAllApplicationList() {
    try {
      setLoader(true)
      let data = JSON.stringify({
        'page': page,
        'limit': pageLimit,
        'application_id': selectedFiltersIds?.apps ? selectedFiltersIds?.apps : null,
        'grade_id': selectedFiltersIds?.grades ? selectedFiltersIds?.grades : null,
        'status': selectedFiltersIds?.status ? selectedFiltersIds?.status : null,
      })
      const response = await applicationService.getAllApplications(data)
      if (response?.response?.success == true) {
        setLoader(false)
        setAllApplicationList(response?.response?.data?.applications)
        setPagination(response?.pagination)
      } else {
        setLoader(false)
        setAllApplicationList([])
      }
    } catch (e) {
      throw e
    }
  }

  async function getAllGradeData() {
    try {
      const response = await applicationService.getAllGrades()
      if (response?.success == true) {
        setAllGradeLIst(response?.data)
      } else {
        setAllGradeLIst([])
      }
    } catch (e) {
      console.error('Error fetching data:', e)
    }
  }

  async function getAllApplicationForFilter() {
    try {
      const response = await applicationService.getAllApplicationForFilter()
      if (response?.success == true) {
        setAllApplicationListFilter(response?.data)
      } else {
        setAllApplicationListFilter([])
      }
    } catch (e) {
      console.error('Error fetching data:', e)
    }
  }

  async function getAllApplicationStatusForFilter() {
    try {
      const response = await applicationService.getAllApplicationStatusForFilter()
      if (response?.success == true) {
        setAllStatusList(response?.data)
      } else {
        setAllStatusList([])
      }
    } catch (e) {
      console.error('Error fetching data:', e)
    }
  }

  // ✅ Export CSV
  // const handleExport = () => {
  //   if (!allApplicationList || allApplicationList.length === 0) {
  //     alert('No data available to export');
  //     return;
  //   }

  //   // Extract column names
  //   const headers = Object.keys(allApplicationList[0]);
  //   const csvRows = [];

  //   // Add headers
  //   csvRows.push(headers.join(','));

  //   // Add rows
  //   for (const row of allApplicationList) {
  //     const values = headers.map(header => {
  //       const escaped = ('' + (row[header] ?? '')).replace(/"/g, '""'); // escape quotes
  //       return `"${escaped}"`;
  //     });
  //     csvRows.push(values.join(','));
  //   }

  //   // Create CSV Blob
  //   const csvData = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });

  //   // Trigger download
  //   const url = URL.createObjectURL(csvData);
  //   const link = document.createElement('a');
  //   link.href = url;
  //   link.setAttribute('download', `applications_export_${new Date().toISOString().slice(0, 10)}.csv`);
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  return (
    <>

      <div className="space-y-6">
        <div className='flex items-center justify-between  p-4'>
          <div>
            {/* <h1 className="text-2xl font-bold text-gray-900">Applications</h1> */}
            {/* <p className="text-gray-600">Browse and access your learning applications</p> */}

            {/* <MultiSelectFilter /> */}
            <Filters filterConfigs={filterConfigs} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} selectedFiltersIds={selectedFiltersIds} setSelectedFiltersIds={setSelectedFiltersIds} />

          </div>

          {/* Only show Add Application button for Admin */}
          {permission?.create === true && (
            <div>
              <button onClick={() => { setIsModalOpen(true); setModelType('New') }} className="bg-brandBlue text-white px-4 flex gap-2 py-2 rounded-lg hover:bg-brandBlue-600 transition">
                <PlusIcon className="w-5 h-5 text-white" />  Add New Application  </button>
            </div>
          )}
        </div>

        {/* <div className="card">
          <div className="card-body">
            <p className="text-gray-600">Applications list will be implemented here.</p>
          </div>
        </div> */}
        <ApplicationTable loader={loader} columns={educatorColumns} data={allApplicationList} showActions={isAdmin} page={page} setPage={setPage} pageLimit={pageLimit} setPageLimit={setPageLimit} pagination={pagination} userRole={userRole} getAllApplicationList={getAllApplicationList} getAllApplicationForFilter={getAllApplicationForFilter} permission={permission}/>
      </div>

      {/* Only show Add Application Modal for Admin */}
      {permission?.create === true && (
        <AddApplicationModal
          isOpen={isModalOpen}
          onClose={setIsModalOpen}
          type={modelType}
          selectedApp={null}
          setSelectedApp={() => { }}
          setModelType={setModelType}
          getAllApplicationList={() => { getAllApplicationList(); getAllApplicationForFilter() }}
        />
      )}

    </>
  )
}

export default ApplicationsList